'use client'

// src/icons/create-icon.tsx
import { createIcon as _createIcon } from "@chakra-ui/react";
var createIcon = (props) => {
  return _createIcon({
    viewBox: "0 0 24 24",
    defaultProps: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    ...props
  });
};

// src/icons/icons.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var ChevronUpIcon = createIcon({
  displayName: "ChevronUpIcon",
  path: /* @__PURE__ */ jsx("polyline", { points: "18 15 12 9 6 15" })
});
var ChevronDownIcon = createIcon({
  displayName: "ChevronDownIcon",
  path: /* @__PURE__ */ jsx("polyline", { points: "6 9 12 15 18 9" })
});
var ChevronLeftIcon = createIcon({
  displayName: "ChevronLeftIcon",
  path: /* @__PURE__ */ jsx("polyline", { points: "15 18 9 12 15 6" })
});
var ChevronRightIcon = createIcon({
  displayName: "ChevronRightIcon",
  path: /* @__PURE__ */ jsx("polyline", { points: "9 18 15 12 9 6" })
});
var HamburgerIcon = createIcon({
  displayName: "ChevronDownIcon",
  path: /* @__PURE__ */ jsxs("g", { fill: "none", children: [
    /* @__PURE__ */ jsx("line", { x1: "3", y1: "12", x2: "21", y2: "12" }),
    /* @__PURE__ */ jsx("line", { x1: "3", y1: "6", x2: "21", y2: "6" }),
    /* @__PURE__ */ jsx("line", { x1: "3", y1: "18", x2: "21", y2: "18" })
  ] })
});
var CloseIcon = createIcon({
  displayName: "CloseIcon",
  path: /* @__PURE__ */ jsxs("g", { children: [
    /* @__PURE__ */ jsx("line", { x1: "18", y1: "6", x2: "6", y2: "18" }),
    /* @__PURE__ */ jsx("line", { x1: "6", y1: "6", x2: "18", y2: "18" })
  ] })
});
var FilterIcon = createIcon({
  displayName: "FilterIcon",
  path: /* @__PURE__ */ jsx("polygon", { points: "22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" })
});
var CalendarIcon = createIcon({
  displayName: "CalendarIcon",
  path: /* @__PURE__ */ jsxs("g", { children: [
    /* @__PURE__ */ jsx("rect", { x: "3", y: "4", width: "18", height: "18", rx: "2", ry: "2" }),
    /* @__PURE__ */ jsx("line", { x1: "16", y1: "2", x2: "16", y2: "6" }),
    /* @__PURE__ */ jsx("line", { x1: "8", y1: "2", x2: "8", y2: "6" }),
    /* @__PURE__ */ jsx("line", { x1: "3", y1: "10", x2: "21", y2: "10" })
  ] })
});
var PlusIcon = createIcon({
  displayName: "PlusIcon",
  path: /* @__PURE__ */ jsxs("g", { children: [
    /* @__PURE__ */ jsx("line", { x1: "12", y1: "5", x2: "12", y2: "19" }),
    /* @__PURE__ */ jsx("line", { x1: "5", y1: "12", x2: "19", y2: "12" })
  ] })
});
var MinusIcon = createIcon({
  displayName: "MinusIcon",
  path: /* @__PURE__ */ jsx("g", { children: /* @__PURE__ */ jsx("line", { x1: "5", y1: "12", x2: "19", y2: "12" }) })
});
var ViewOffIcon = createIcon({
  displayName: "ViewOffIcon",
  path: /* @__PURE__ */ jsxs("g", { children: [
    /* @__PURE__ */ jsx("path", { d: "M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" }),
    /* @__PURE__ */ jsx("line", { x1: "1", y1: "1", x2: "23", y2: "23" })
  ] })
});
var ViewIcon = createIcon({
  displayName: "ViewOffIcon",
  path: /* @__PURE__ */ jsxs("g", { children: [
    /* @__PURE__ */ jsx("path", { d: "M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" }),
    /* @__PURE__ */ jsx("circle", { cx: "12", cy: "12", r: "3" })
  ] })
});
var SearchIcon = createIcon({
  displayName: "SearchIcon",
  path: /* @__PURE__ */ jsxs("g", { children: [
    /* @__PURE__ */ jsx("circle", { cx: "11", cy: "11", r: "8" }),
    /* @__PURE__ */ jsx("line", { x1: "21", y1: "21", x2: "16.65", y2: "16.65" })
  ] })
});
var CheckIcon = createIcon({
  displayName: "CheckIcon",
  path: /* @__PURE__ */ jsx("g", { children: /* @__PURE__ */ jsx("polyline", { points: "20 6 9 17 4 12" }) })
});

export {
  createIcon,
  ChevronUpIcon,
  ChevronDownIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  HamburgerIcon,
  CloseIcon,
  FilterIcon,
  CalendarIcon,
  PlusIcon,
  MinusIcon,
  ViewOffIcon,
  ViewIcon,
  SearchIcon,
  CheckIcon
};
//# sourceMappingURL=chunk-KRTCJUOH.mjs.map